import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DirtyFormGuard } from 'dirty-check-store';
import { PocComponent } from './poc/poc.component';
import { VdBuilderContainerComponent } from './vd-builder-container/vd-builder-container.component';
import { VdBuilderReviewComponent } from './vd-builder-review/vd-builder-review.component';
import { VdBuilderStepsNavigatorComponent } from './vd-builder-steps-navigator/vd-builder-steps-navigator.component';
import { VdBuilderTaskSectionComponent } from './vd-builder-task-section/vd-builder-task-section.component';
import { VdBuilderTimelineCreateStepsComponent } from './vd-builder-timeline-create-steps/vd-builder-timeline-create-steps.component';
import { VdBuilderTimelineStepsComponent } from './vd-builder-timeline-steps/vd-builder-timeline-steps.component';
import { VdContainerComponent } from './vd-container/vd-container.component';
import { VdCreatedListComponent } from './vd-created-list/vd-created-list.component';
import { VdDefaultTemplateComponent } from './vd-default-template/vd-default-template.component';
import { VdGenerateLettersComponent } from './vd-generate-letters/vd-generate-letters.component';
import { VdLettersElementsComponent } from './vd-letters-elements/vd-letters-elements.component';
import { VdStandardListComponent } from './vd-standard-list/vd-standard-list.component';
import { VdVisaCreationComponent } from './vd-visa-creation/vd-visa-creation.component';
import { VdBuilderFormMappingComponent } from './vd-builder-form-mapping/vd-builder-form-mapping';
import { VdBuilderBuildStepsComponent } from './vd-builder-build-steps/vd-builder-build-steps.component';
import { UploadPdfComponent } from './upload-pdf/upload-pdf.component';
import { VdJsonViewerComponent } from './vd-json-viewer/vd-json-viewer.component';

const routes: Routes = [
  {
    path: 'poc',
    component: PocComponent,
    pathMatch: 'full'
  },
  {
    path: 'manage-visa',
    component: VdContainerComponent,
    children: [{
      path: '',
      redirectTo: 'created-visas'
    }, {
      path: 'created-visas',
      pathMatch: 'full',
      component: VdCreatedListComponent
    }, {
      path: 'standard-visas',
      pathMatch: 'full',
      component: VdStandardListComponent
    }]
  },
  {
    path: 'visa-builder',
    component: VdBuilderContainerComponent,
    children: [
      {
        path: 'create-visa/:id',
        component: VdVisaCreationComponent
      },
      {
        path: 'create-visa/new',
        component: VdVisaCreationComponent,
        canDeactivate: [DirtyFormGuard]
      },
      {
        path: 'create-visa/:id/:isDuplicate',
        component: VdVisaCreationComponent
      },
      {
        path: 'create-visa/:id/:isRepublish',
        component: VdVisaCreationComponent
      },
      {
        path: '',
        redirectTo: 'create-visa/new'
      },

      {
        path: 'visa-details-steps/:id',
        component: VdBuilderStepsNavigatorComponent,
        children: [
          {
            path: 'task-details',
            // component: VdBuilderTaskSectionComponent
            component: PocComponent
          },{
            path: 'task-details/:isView',
            // component: VdBuilderTaskSectionComponent
            component: PocComponent
          }, {
            path: 'timeline-steps',
            component: VdBuilderTimelineStepsComponent
          },
          {
            path: 'timeline-steps/:isView',
            component: VdBuilderTimelineStepsComponent
          },
          {
            path: 'timeline-create-steps',
            component: VdBuilderTimelineCreateStepsComponent
          },
          {
            path: 'timeline-create-steps/:isView',
            component: VdBuilderTimelineCreateStepsComponent
          },
          {
            path: 'form-mapping',
            component: VdBuilderFormMappingComponent
          },
          {
            path: 'generate-letters',
            component: VdGenerateLettersComponent
          },
          {
            path: 'generate-letters/elements',
            component: VdLettersElementsComponent
          },
          {
            path: 'generate-letters/default-template',
            canDeactivate: [DirtyFormGuard],
            component: VdDefaultTemplateComponent
          }, {
            path: 'review',
            component: VdBuilderReviewComponent
          },{
            path: 'review/:isView',
            component: VdBuilderReviewComponent
          }, {
            path: 'upload-pdf',
            component: UploadPdfComponent
          },
          {
            path: 'upload-pdf/:isView',
            component: UploadPdfComponent
          },
          {
            path: 'build-steps',
            component: VdBuilderBuildStepsComponent
          },
          {
            path: 'build-steps/:isView',
            component: VdBuilderBuildStepsComponent
          },
          {
            path: 'json-viewer',
            component: VdJsonViewerComponent
          },
          {
            path: 'json-viewer/:isView',
            component: VdJsonViewerComponent
          },
          {
            path: '',
            redirectTo: 'task-details'
          }]
      }]
  },
  {
    path: '',
    redirectTo: 'manage-visa'
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class VisaDesignerRoutingModule { }
